var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column" },
    [
      _c(
        "el-form-item",
        {
          staticClass: "flex-column",
          attrs: { prop: "type", label: _vm.$t.__("common.labels.type") }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-5",
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            },
            _vm._l(_vm.types, function(option) {
              return _c("el-option", {
                key: option.label,
                attrs: { value: option.value, label: option.label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "flex-column",
          attrs: {
            prop: "civility",
            label: _vm.$t.__("common.labels.civility")
          }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-5",
              model: {
                value: _vm.civility,
                callback: function($$v) {
                  _vm.civility = $$v
                },
                expression: "civility"
              }
            },
            _vm._l(_vm.civilities, function(option) {
              return _c("el-option", {
                key: option.label,
                attrs: { value: option.value, label: option.label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "name", label: _vm.$t.__("common.labels.name") } },
        [
          _c("el-input", {
            ref: "name",
            attrs: { name: "lastname", autocomplete: "off" },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "firstName",
            label: _vm.$t.__("common.labels.first_name")
          }
        },
        [
          _c("el-input", {
            attrs: { name: "firstname", autocomplete: "off" },
            model: {
              value: _vm.firstName,
              callback: function($$v) {
                _vm.firstName = $$v
              },
              expression: "firstName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "birthDate",
            label: _vm.$t.__("common.labels.birthdate")
          }
        },
        [
          _c("el-date-picker", {
            attrs: {
              type: "date",
              "default-value": "01-01-1990",
              format: _vm.datePickerFormat,
              placeholder: _vm.datePickerFormat.toUpperCase()
            },
            model: {
              value: _vm.birthDate,
              callback: function($$v) {
                _vm.birthDate = $$v
              },
              expression: "birthDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "email", label: _vm.$t.__("common.labels.email") } },
        [
          _c("el-input", {
            attrs: { type: "email", autocomplete: "off" },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-number", {
        attrs: { currentStore: _vm.storeModule, error: _vm.error }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }